import { formatSupabaseError } from './formatSupabaseError';
import { getDbSupabase } from './supabase';

/** Wall-clock seconds since session start (floor, min 1 if any positive elapsed). */
export function elapsedProcessingSeconds(startedAtMs: number | null | undefined): number {
  if (startedAtMs == null || !Number.isFinite(startedAtMs)) return 0;
  const sec = Math.floor((Date.now() - startedAtMs) / 1000);
  return sec > 0 ? sec : 0;
}

/** Human-readable duration for order detail (e.g. "4m 12s", "1h 3m"). */
export function formatProcessingDuration(seconds: number | null | undefined): string {
  if (seconds == null || !Number.isFinite(seconds) || seconds <= 0) return '—';
  const total = Math.floor(seconds);
  const h = Math.floor(total / 3600);
  const m = Math.floor((total % 3600) / 60);
  const s = total % 60;
  if (h > 0) return m > 0 ? `${h}h ${m}m` : `${h}h`;
  if (m > 0) return s > 0 ? `${m}m ${s}s` : `${m}m`;
  return `${s}s`;
}

/**
 * Add seconds onto orders.processing_seconds (treat null as 0).
 * Used for amend sessions and when the create insert omitted the field.
 */
export async function addOrderProcessingSeconds(
  orderId: string,
  seconds: number,
): Promise<void> {
  const id = orderId.trim();
  const add = Math.floor(seconds);
  if (!id || add <= 0) return;

  const db = getDbSupabase('dem');
  const { data, error } = await db
    .from('orders')
    .select('processing_seconds')
    .eq('order_id', id)
    .maybeSingle();
  if (error) throw new Error(formatSupabaseError(error));

  const current = Number((data as { processing_seconds?: number | null } | null)?.processing_seconds);
  const base = Number.isFinite(current) && current > 0 ? current : 0;
  const next = base + add;

  const { error: upError } = await db
    .from('orders')
    .update({ processing_seconds: next })
    .eq('order_id', id);
  if (upError) throw new Error(formatSupabaseError(upError));
}
